import { useEffect, useRef } from 'react';
import type { AssistantTurn, UserEvent } from '../state/conversationStore';

interface Props {
  turns: AssistantTurn[];
  userEvents: UserEvent[];
}

export function ConversationView({ turns, userEvents }: Props) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const items = [
    ...userEvents.map((e) => ({ kind: 'user' as const, at: e.created_at, data: e })),
    ...turns.map((t) => ({ kind: 'assistant' as const, at: t.created_at, data: t })),
  ].sort((a, b) => (a.at < b.at ? -1 : 1));

  // Auto-scroll to the latest message when new content arrives (new turn
  // or streaming text update). Reads turn count + last turn text length
  // so effect re-runs during token streaming, not just on turn boundaries.
  const lastText = turns.at(-1)?.text ?? '';
  useEffect(() => {
    const el = containerRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [items.length, lastText]);

  return (
    <div
      ref={containerRef}
      style={{ border: '1px solid #ccc', padding: 12, borderRadius: 8, maxHeight: 400, overflow: 'auto' }}
    >
      {items.length === 0 && <p style={{ color: '#888' }}>会話はまだありません。マイクを開始して話しかけてください。</p>}
      {items.map((it) =>
        it.kind === 'user' ? (
          <div key={it.data.id} style={{ margin: '8px 0', color: '#555' }}>
            👤 <span>（音声 {it.data.durationSec.toFixed(1)}s）</span>
          </div>
        ) : (
          <div key={it.data.id} style={{ margin: '8px 0' }}>
            🤖 <strong>{it.data.model}</strong>{' '}
            {it.data.first_token_ms !== undefined && (
              <span style={{ color: '#888', fontSize: 12 }}>first={it.data.first_token_ms}ms / total={it.data.total_ms}ms</span>
            )}
            <div style={{ marginLeft: 24, whiteSpace: 'pre-wrap' }}>{it.data.text || '（生成中…）'}</div>
          </div>
        ),
      )}
    </div>
  );
}
